export default __webpack_public_path__ + "static/media/statementofwork.c3003d40.md";